'use client';

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";

const BrandMark = ({ stroke = "#024ad8" }: { stroke?: string }) => (
    <svg className="brand__mark" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="20" cy="20" r="18" stroke={stroke} strokeWidth="2" />
        <path d="M6 20 L14 16 L26 24 L34 20" stroke={stroke} strokeWidth="2" fill="none" strokeLinecap="round" />
        <circle cx="20" cy="20" r="3" fill={stroke} />
    </svg>
);

const NAV_LINKS = [
    { label: "Home", href: "/" },
    { label: "Articles", href: "/blog" },
    { label: "About", href: "/about" },
    { label: "Author", href: "/author" },
    { label: "Contact", href: "/contact" },
];

// Legal / AdSense-compliance pages — shown in the top black bar, separate from the main menu.
const COMPLIANCE_LINKS = [
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Terms", href: "/terms-conditions" },
    { label: "Disclaimer", href: "/disclaimer" },
    { label: "Cookie Policy", href: "/cookie-policy" },
    { label: "DMCA", href: "/dmca" },
];

export default function Header() {
    const pathname = usePathname();
    const [open, setOpen] = useState(false);

    const isActive = (href: string) =>
        href === "/" ? pathname === "/" : pathname.startsWith(href);

    return (
        <>
            <div className="util-strip">
                <div className="util-strip__left">
                    <span>The physics of light, lenses, and waves — explained from first principles</span>
                </div>
                <nav className="util-strip__right" aria-label="Legal">
                    {COMPLIANCE_LINKS.map((link) => (
                        <Link key={link.href} href={link.href}>{link.label}</Link>
                    ))}
                </nav>
            </div>

            <header className="top-nav">
                <div className="top-nav__inner">
                    <Link href="/" className="brand">
                        <BrandMark />
                        <div className="brand__wrap">
                            <span className="brand__name">Physics Optics</span>
                            <span className="brand__sub">The science of light</span>
                        </div>
                    </Link>

                    <nav className="top-nav__links" aria-label="Main navigation">
                        {NAV_LINKS.map((link, i) => (
                            <Link
                                key={i}
                                href={link.href}
                                className="top-nav__link"
                                data-active={isActive(link.href) ? "true" : undefined}
                            >
                                {link.label}
                            </Link>
                        ))}
                    </nav>

                    <div className="top-nav__right">
                        <button
                            type="button"
                            className="top-nav__burger"
                            aria-label="Toggle menu"
                            aria-expanded={open}
                            onClick={() => setOpen((v) => !v)}
                        >
                            {open ? (
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M6 6l12 12M18 6 6 18" /></svg>
                            ) : (
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M3 6h18M3 12h18M3 18h18" /></svg>
                            )}
                        </button>
                    </div>
                </div>

                <div className="mobile-panel" data-open={open ? "true" : "false"}>
                    {NAV_LINKS.map((link, i) => (
                        <Link key={i} href={link.href} onClick={() => setOpen(false)}>
                            {link.label}
                        </Link>
                    ))}
                </div>
            </header>
        </>
    );
}
